export default __webpack_public_path__ + "static/dot-pattern-d6efeb891d0e87bf4a2af3ae59580f43.svg";